/* Hover solo con mouse desktop. Click e tastiera restano quelli nativi di Focal. */
(() => {
  if (window.extroProductHoverReady) return;
  window.extroProductHoverReady = true;
  const desktop = matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  const scopeSelector = '[data-extro-product-hover]';
  const targetSelector = 'variant-picker .variant-swatch__item, product-media .product__thumbnail-item[data-action="select"]';
  let timer;
  const cancel = () => clearTimeout(timer);

  customElements.whenDefined('variant-picker').then(() => {
    // Le risposte Shopify possono arrivare fuori ordine: un cambio alla volta,
    // conservando soltanto l'ultima selezione in attesa, anche dopo il rerender.
    const prototype = customElements.get('variant-picker').prototype;
    const nativeSelect = prototype.selectCombination;
    const queues = new WeakMap();
    prototype.selectCombination = function(options) {
      const scope = this.closest(scopeSelector);
      if (!scope) return nativeSelect.call(this, options);
      let state = queues.get(scope);
      if (!state) { state = { running: false, next: null }; queues.set(scope, state); }
      return new Promise((resolve, reject) => {
        if (state.next) state.next.resolve();
        state.next = { picker: this, options, resolve, reject };
        if (state.running) return;
        const drain = async () => {
          state.running = true;
          scope.setAttribute('data-extro-variant-pending', '');
          scope.dispatchEvent(new Event('extro:variant-pending'));
          try {
            while (state.next) {
              const job = state.next;
              state.next = null;
              const picker = job.picker.isConnected ? job.picker : scope.querySelector(`variant-picker[form-id="${CSS.escape(job.picker.getAttribute('form-id'))}"]`);
              if (!scope.isConnected || !picker) { job.resolve(); continue; }
              try { job.resolve(await nativeSelect.call(picker, job.options)); }
              catch (error) { job.reject(error); }
            }
          } finally {
            state.running = false;
            scope.removeAttribute('data-extro-variant-pending');
            scope.dispatchEvent(new Event('extro:variant-pending'));
          }
        };
        drain();
      });
    };

    document.addEventListener('pointerover', event => {
      if (!desktop.matches || event.pointerType !== 'mouse') return;
      const target = event.target.closest(targetSelector);
      if (!target || !target.closest(scopeSelector) || target.contains(event.relatedTarget)) return;
      cancel();
      if (target.hasAttribute('data-extro-notify-color')) return;
      if (target.matches('[aria-current="true"],.is-selected,.is-filtered') || target.control?.checked || target.control?.disabled) return;
      timer = setTimeout(() => {
        if (!desktop.matches || !target.isConnected || document.hidden) return;
        // Anche i prodotti collegati conservano il loro normale link di destinazione.
        target.click();
      }, target.matches('.product__thumbnail-item') ? 40 : 160);
    });
    document.addEventListener('pointerout', event => {
      const target = event.target.closest(targetSelector);
      if (target && !target.contains(event.relatedTarget)) cancel();
    });
    document.addEventListener('pointerdown', cancel);
    document.addEventListener('visibilitychange', cancel);
    document.addEventListener('shopify:section:unload', cancel);
    window.addEventListener('blur', cancel);
    desktop.addEventListener('change', cancel);
  });
})();
